import {
  BrandDeal,
  DealType,
  PaymentType,
  ClauseType,
  EquityType,
} from "@quantizr-engineering/common/types/brand-deal";

export interface MgrPaymentRow {
  paymentType: PaymentType;
  cashPayment: number | null;
  cashPaymentDue: Date | null;
  cashDeposit: number | null;
  cashDepositDate: Date | null;
  equityComp: string | null;
  equityType: EquityType | null;
  vestingSummary: string | null;
  vestedDate: Date | null;
  performanceThreshhold: string | null;
  performanceCompensation: string | null;
}

export interface MgrDeliverableRow {
  item: string;
  details: string;
  dueDate: Date | null;
  cadence: string | null;
  quantity: number | null;
}

export interface MgrBrandDealDataRow {
  talent: string;
  talentAgency: string;
  brand: string;
  brandAgency: string;
  effectiveDate: Date;
  term: string;
  terminationDate: Date;
  dealType: DealType;
  paymentTotal: number;
  exclusivitySummary: string;
  paymentSummary: string;
  deliverablesSummary: string;
  hasAutoRenew: boolean;
  hasFtcRisk: boolean;
  hasIndemnification: boolean;
  hasIpAssignment: boolean;
  hasConfidentiality: boolean;
  children: MgrPaymentRow[];
}

export class MgrBrandDealDataRowAdapter {
  toContracts(deals: BrandDeal[]): MgrBrandDealDataRow[] {
    return deals.map((deal) => {
      const row: MgrBrandDealDataRow = {
        talent: deal.talent,
        talentAgency: deal.talentAgency,
        brand: deal.brand,
        brandAgency: deal.brandAgency || "Direct",
        effectiveDate: deal.effectiveDate,
        term: deal.term,
        terminationDate: deal.terminationDate ?? new Date(), // clean this nullish default up
        dealType: deal.dealType,
        paymentTotal: deal.payments.reduce(
          (total, payment) => total + (payment?.cashPayment ?? 0),
          0
        ),
        exclusivitySummary: deal.exclusivitySummary || "None",
        paymentSummary: deal.paymentSummary,
        deliverablesSummary: deal.deliverablesSummary,
        hasAutoRenew: deal.renewalAutomatic,
        hasFtcRisk: deal.clauses.some(
          (c) => c.type === ClauseType.FTC_RISK && c.isPresent
        ),
        hasIndemnification: deal.clauses.some(
          (c) => c.type === ClauseType.INDEMNIFICATION && c.isPresent
        ),
        hasIpAssignment: deal.clauses.some(
          (c) => c.type === ClauseType.IP_ASSIGNMENT && c.isPresent
        ),
        hasConfidentiality: deal.clauses.some(
          (c) => c.type === ClauseType.CONFIDENTIALITY && c.isPresent
        ),
        children: deal.payments,
      };

      return row;
    });
  }
}
